import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ExploreEventCard from "../../components/exploreEventCard/ExploreEventCard.jsx";
import { eventService } from "../../helper/eventService.js";
import ExploreEventCardSkeleton from "../skeletons/ExploreEventCardSkeleton.jsx";
import "./ExploreSection.css";

const ExploreSection = () => {
  const navigate = useNavigate();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [initialLoading, setInitialLoading] = useState(true);

  const PREVIEW_EVENTS_COUNT = 6;

  useEffect(() => {
    fetchEvents();
  }, []);

  const getEventPrimaryDate = (event) => {
    if (event.eventDate) {
      return new Date(event.eventDate);
    }
    if (event.startDate) {
      return new Date(event.startDate);
    }
    if (event.multipleDates && event.multipleDates.length > 0) {
      const sortedDates = event.multipleDates
        .map((d) => new Date(d.date))
        .sort((a, b) => a - b);
      return sortedDates[0];
    }
    return new Date(0);
  };

  const sortEventsByDate = (eventsArray) => {
    return [...eventsArray].sort((a, b) => {
      const dateA = getEventPrimaryDate(a);
      const dateB = getEventPrimaryDate(b);
      return dateA - dateB;
    });
  };

  const fetchEvents = async () => {
    const payload = {
      page: 1,
      perPage: PREVIEW_EVENTS_COUNT,
      sortBy: "date-asc",
    };
    try {
      setLoading(true);
      setError(null);

      const response = await eventService.getPublicEvents(payload);

      const sortedEvents = sortEventsByDate(response.data || []);

      setEvents(sortedEvents);
    } catch (err) {
      setError("Failed to load events. Please try again later.");
    } finally {
      setLoading(false);
      setInitialLoading(false);
    }
  };

  const handleSeeMore = () => {
    window.scrollTo({ top: 0, behavior: "instant" });
    navigate("/explore");
  };

  if (error) {
    return (
      <section className="explore-section">
        <div className="explore-section-container">
          <div className="explore-section-error-message">
            <p>{error}</p>
            <button
              onClick={fetchEvents}
              className="explore-section-retry-button"
            >
              Retry
            </button>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="explore-section">
      <div className="explore-section-container">
        <div className="explore-section-header">
          <h2 className="explore-section-title">Discover Events</h2>
          <p className="explore-section-subtitle">
            Find exciting events happening around you
          </p>
        </div>

        {initialLoading ? (
          <div className="explore-section-events-grid">
            {Array.from({ length: PREVIEW_EVENTS_COUNT }).map((_, i) => (
              <ExploreEventCardSkeleton key={i} />
            ))}
          </div>
        ) : (
          <>
            {events.length > 0 ? (
              <div className="explore-section-events-grid">
                {events.map((event) => (
                  <ExploreEventCard
                    key={event._id || event.id}
                    event={event}
                    showShareButton={false}
                  />
                ))}
              </div>
            ) : (
              <div className="explore-section-no-events-message">
                <p>No events available at the moment.</p>
                <p className="explore-section-sub-message">
                  Check back soon for upcoming events!
                </p>
              </div>
            )}

            {events.length > 0 && (
              <div className="explore-section-see-more-container">
                <button
                  className="explore-section-btn-see-more"
                  onClick={handleSeeMore}
                >
                  See More Events
                  <span className="explore-section-arrow-icon">→</span>
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </section>
  );
};

export default ExploreSection;
